// extracted by mini-css-extract-plugin
module.exports = {"content":"FeedbackScreen_content__2xRgf","icon":"FeedbackScreen_icon__3YszO","header":"FeedbackScreen_header__3eVfS","descriptionText":"FeedbackScreen_descriptionText__17mVi"};